/** The Daily Run (docs/spec/03 §6): one seed per UTC day, the same for everyone. Pure. */

import { seedFromText } from '../sim/rng';

export interface Day {
  readonly year: number;
  readonly month: number;
  readonly day: number;
}

/** `2026-10-08`. */
export function dateKey(d: Day): string {
  const two = (n: number): string => String(n).padStart(2, '0');
  return `${d.year}-${two(d.month)}-${two(d.day)}`;
}

export function dailySeed(d: Day): number {
  return seedFromText(dateKey(d));
}

/** The run's number: days since STARHIVE's first day, counting from 1. */
export function dailyNumber(d: Day): number {
  // Days from civil date (Howard Hinnant's algorithm), integer arithmetic only.
  const days = (y0: number, m: number, day: number): number => {
    const y = m <= 2 ? y0 - 1 : y0;
    const era = Math.floor(y / 400);
    const yoe = y - era * 400;
    const doy = Math.floor((153 * (m + (m > 2 ? -3 : 9)) + 2) / 5) + day - 1;
    const doe = yoe * 365 + Math.floor(yoe / 4) - Math.floor(yoe / 100) + doy;
    return era * 146097 + doe;
  };
  return days(d.year, d.month, d.day) - days(2026, 10, 8) + 1;
}
